import { fontSize, size } from '@styles/theme'
import { formatDistance } from 'date-fns'
import styled from '@emotion/styled'

import { PiDotBold, PiDotsThreeOutlineVerticalFill } from 'react-icons/pi'
import { SubscriberIcon } from '@elements/icons/SubscriberIcon'
import { ButtonBase } from '@mui/material'

const HeadingContainer = styled.div`
  width: 100%;
`

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const UserName = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
`

const HeadingActions = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${size(0.25)};
  flex-shrink: 0;
  color: grey;
  font-size: ${fontSize('sm')}
`

const PostHeading = ({ user, post, isReplyBottom, handleThreeDotsClick }) => {

  const renderDateCreated = () => {
    if (post.createdAt) {
      let time = formatDistance(new Date(post.createdAt), Date.now())
      time = time.replace('about ', '')
      return time
    }
  }

  return (
    // <HeadingContainer style={{ height: isReplyBottom ? size(5) : size(2.5) }}>
    <HeadingContainer style={{ height: size(2.5) }}>
      <Heading
        // heading.titleHeight
        style={{ height: size(2.5) }}
        className='post-clickable'>
        <UserName>
          <span style={{ fontWeight: 600 }}>{user?.displayName}</span>
          {user?.isSubscribed && <>&nbsp;<SubscriberIcon /></>}
          <span style={{ color: 'grey', fontSize: fontSize('sm') }}>&nbsp;@{user?.handle}</span>
        </UserName>
        <HeadingActions>
          <PiDotBold fill='grey' size={size(1.5)} />
          {renderDateCreated()}
          <ButtonBase onClick={handleThreeDotsClick}>
            <PiDotsThreeOutlineVerticalFill fill='grey' size={size(2)} style={{ marginLeft: size(1) }} />
          </ButtonBase>
        </HeadingActions>
      </Heading>
                                      {/* heading.replyHandleHeight  */}
      {/* {isReplyBottom && <span style={{ height: size(2.5), width: '100%', fontSize: '14px', color: 'grey', display: 'inline-block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>Replying to <Link onClick={e => e.stopPropagation()} to={`/profiles/${post?.parentPoster?.uuid}`} style={{ color: colors.statusColors.right_now('primary'), textDecoration: 'none' }}>@{post?.parentPoster?.handle}</Link></span> } */}
    </HeadingContainer>
  )
}

export { PostHeading }
